import apiClient from './apiClient';

export type DocumentTypeFilter =
  | 'all'
  | 'photo'
  | 'delivery_note'
  | 'certificate'
  | 'insurance'
  | 'permit'
  | 'contract'
  | 'invoice'
  | 'drawing'
  | 'report'
  | 'drawdown_packet'
  | 'other';

export type DocumentStatusFilter =
  | 'all'
  | 'draft'
  | 'submitted'
  | 'approved'
  | 'rejected'
  | 'expired'
  | 'replaced';

export interface DocumentRegisterRow {
  id: string;
  title: string;
  description: string | null;
  documentType: string;
  status: string;
  fileName: string;
  fileType: string;
  mimeType: string | null;
  fileUrl: string;
  fileSizeKb: number | null;
  version: number;
  supersedesDocumentId: string | null;
  isCurrent: boolean;
  uploadedBy: string | null;
  uploadedByName: string | null;
  reviewedBy: string | null;
  reviewedAt: string | null;
  createdAt: string;
  updatedAt: string;
  taskId: string | null;
  taskCode: string | null;
  wbsId: number | null;
  wbsName: string | null;
  drawingNumber: string | null;
  discipline: string | null;
  revisionCode: string | null;
}

export interface DocumentRegister {
  documents: DocumentRegisterRow[];
  totals: {
    count: number;
    byType: Record<string, number>;
    byStatus: Record<string, number>;
    activeDrawings: number;
    supersededDrawings: number;
    drawingConflicts: number;
  };
  drawingConflicts: Array<{
    taskId: string;
    taskCode: string;
    taskName: string;
    drawingId: string;
    drawingNumber: string | null;
    drawingTitle: string;
    drawingStatus: string;
  }>;
}

class DocumentService {
  async getRegister(
    projectId: string,
    filters: { documentType?: DocumentTypeFilter; status?: DocumentStatusFilter; currentOnly?: boolean } = {}
  ): Promise<DocumentRegister> {
    const params: Record<string, string> = {};
    if (filters.documentType && filters.documentType !== 'all') params.documentType = filters.documentType;
    if (filters.status && filters.status !== 'all') params.status = filters.status;
    if (filters.currentOnly) params.currentOnly = 'true';
    const response: any = await apiClient.get(`/documents/project/${projectId}/register`, { params });
    return response.data;
  }

  async downloadFile(documentId: string): Promise<Blob> {
    return await apiClient.get(`/documents/${documentId}/file`, { responseType: 'blob' }) as unknown as Blob;
  }
}

export default new DocumentService();
